export class BaseModel {
    id: number = 0;
}